const API_BASE_URL = 'https://marketluz.com/laravel8/public/api';

export const loginUser = async (email,password) => {
  try {
    const response = await fetch(`${API_BASE_URL}/login`,{
      method:'POST',
      headers:{
        'Content-Type':'application/json',
      },
      body: JSON.stringify({
        email,
        password,
      })
    });

    if(!response.ok){
      const errorData = await response.json();
      console.warn('Login failed:', errorData);

      return {
        message: 'invalid credentials', // or customize based on errorData
      };
    }

    const data = await response.json();
    console.log("data righ after fetch:");
    console.log(data);
    return data;
  } catch (error) {
    console.error('Error login:', error);
    throw error;
  }
};
